import React from 'react';
import { Button } from 'react-bootstrap';
import { boxArrowUpRightIcon } from './icons';
import { logEventToGoogleAnalytics } from '../../utilities/log-event-to-google-analytics';
import './externalstreamoverlay.css';

function getDomainInfo(url) {
  try {
    const parsed = new URL(url);
    const hostname = parsed.hostname.replace('www.', '');
    const domainMap = {
      'espn.com': 'ESPN',
      'cbssports.com': 'CBS Sports',
      'nbcsports.com': 'NBC Sports',
      'foxsports.com': 'FOX Sports',
      'peacocktv.com': 'Peacock',
      'paramountplus.com': 'Paramount+',
      'flogymnastics.com': 'FloGymnastics',
      'flosports.tv': 'FloSports',
    };
    let label = hostname;
    for (const [domain, name] of Object.entries(domainMap)) {
      if (hostname.includes(domain)) {
        label = name;
        break;
      }
    }
    const favicon = `https://www.google.com/s2/favicons?domain=${hostname}&sz=64`;
    return { label, favicon };
  } catch {
    return { label: 'External Stream', favicon: null };
  }
}

function ExternalStreamOverlay({ url, location }) {
  const { label, favicon } = getDomainInfo(url);
  const [copied, setCopied] = React.useState(false);

  const handleOpen = () => {
    logEventToGoogleAnalytics('external_stream_click', {
      provider: label,
      url,
      location: location || 'unknown',
    });
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="externalStreamOverlay">
      <div className="externalStreamContent">
        <Button
          variant="outline-light"
          className="externalStreamButton"
          onClick={handleOpen}
        >
          {favicon && (
            <img className="externalStreamFavicon" src={favicon} alt={label} />
          )}
          <span>Watch on {label}</span>
          {boxArrowUpRightIcon}
        </Button>
        <button
          type="button"
          className={`externalStreamUrl${
            copied ? ' externalStreamUrlCopied' : ''
          }`}
          onClick={handleCopy}
          title="Click to copy"
        >
          <span className="externalStreamUrlText">{url}</span>
          {copied && <span className="externalStreamUrlBadge">Copied!</span>}
        </button>
      </div>
    </div>
  );
}

export default ExternalStreamOverlay;
